import { ROUTES } from 'constants/routes';
import { getFullAddress } from 'helpers/address';
import React from 'react';
import { Edit, List } from 'react-feather';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';

import { Loading, NOTIFICATION_TYPE, Notification } from 'components';
import { useGetExporter } from 'features/sellers/hooks/useGetExporter';

export function ViewExporter() {
  const { id } = useParams();
  const {
    data: exporter,
    isLoading,
    error,
  } = useGetExporter(id, {
    onError: (error) => {
      Notification(NOTIFICATION_TYPE.DANGER, error.message);
    },
  });

  if (isLoading) {
    return <Loading />;
  }

  if (error) {
    return <p>{error.message}</p>;
  }

  return (
    <div>
      <div className="mb-2 d-flex align-items-center justify-content-between">
        <h2>Seller Details</h2>
        <div className="d-flex gap-4">
          <Link
            to={`${ROUTES.MAIN.USER_SETTINGS.SELLERS}`}
            className="text-white d-flex align-items-center gap-2"
          >
            <List size={20} />
            List
          </Link>
          <Link
            to={`${ROUTES.MAIN.USER_SETTINGS.SELLERS}/edit/${id}`}
            className="text-white d-flex align-items-center gap-2"
          >
            <Edit size={20} />
            Edit
          </Link>
        </div>
      </div>
      <hr />
      <h5>Company Name</h5>
      <p>{exporter?.companyName}</p>
      <h5>Company Phone</h5>
      <p>{exporter?.companyPhone || '-'}</p>
      <h5>Tax ID</h5>
      <p>{exporter?.taxID || '-'}</p>
      <h5>Organization Code</h5>
      <p>{exporter?.user?.orgCode || '-'}</p>
      <h5>Contact Person</h5>
      <p>{`${exporter?.user?.firstName} ${exporter?.user?.lastName}`}</p>
      <h5>Contact Email</h5>
      <p>{exporter?.user?.email}</p>
      <h5>Contact Phone</h5>
      <p>{exporter?.user?.phoneNumber}</p>
      <h5>Contact Address</h5>
      <p>
        {getFullAddress([
          exporter?.user?.street1,
          exporter?.user?.city1,
          exporter?.user?.state1,
          exporter?.user?.zip1,
          exporter?.user?.country1,
        ])}
      </p>
    </div>
  );
}
